import React from 'react';
import FundingMatchClientSelector from './FundingMatchClientSelector';

const FundingSequenceClientSelector = (props) => <FundingMatchClientSelector {...props} />;

export default FundingSequenceClientSelector;
